import { render, staticRenderFns } from "./TaskAddModal.vue?vue&type=template&id=205c25a8"
import script from "./TaskAddModal.vue?vue&type=script&lang=js"
export * from "./TaskAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports